import { DefaultButton } from "OfficeFabric/Button";
import {
    MessageBar,
    MessageBarType
} from "OfficeFabric/MessageBar";
import { Spinner } from "OfficeFabric/Spinner";
import { getAsyncLoadedComponent } from "VSS/Flux/AsyncLoadedComponent";
import "VSS/LoaderPlugins/Css!VersionControl/InlineGitCredentialsSection";
import * as PatTokenComponent_Async from "VersionControl/Scenarios/NewGettingStarted/Components/GitCredentials/PatTokenComponent";
import { DelayAnnounceHelper } from "VersionControl/Scripts/DelayAnnounceHelper";
import * as VCResources from "VersionControl/Scripts/Resources/TFS.Resources.VersionControl";
import { FeatureAvailabilityService } from "VSS/FeatureAvailability/Services";
import * as React from "react";

export interface InlineGitCredentialsProps {
    onGenerateGitCredentialsButtonClicked(): void;
    onDismissErrorMessage(): void;
    isGenerateGitCredentialsButtonClicked: boolean;
    patTokenComponentProps: PatTokenComponent_Async.PatTokenComponentProps;
    errorMessage: string;
}

const delayAnnounceHelper = new DelayAnnounceHelper();

export const InlineGitCredentialsSection = (props: InlineGitCredentialsProps): JSX.Element => {
    if (FeatureAvailabilityService.isFeatureEnabled("WebAccess.Wiki.Clone.NewPATPolicy", false)) {
        if (props.isGenerateGitCredentialsButtonClicked) {
            return (
                <div className="git-getting-started-credentials-container">
                    {props.errorMessage &&
                        <MessageBar
                            className="error-message-bar"
                            onDismiss={props.onDismissErrorMessage}
                            messageBarType={MessageBarType.error}>
                            {props.errorMessage}
                        </MessageBar>
                    }
                    <span className="vc-inline-git-credentials-control-body">
                        <AsyncPatTokenComponent {...props.patTokenComponentProps} />
                    </span>
                </div>
            );
        }
        if (!props.isGenerateGitCredentialsButtonClicked || props.errorMessage) {
            return (
                <DefaultButton
                    id="vc-inline-git-credentials-create-credentials-button"
                    ariaLabel={VCResources.CreatePatButtonText}
                    onClick={props.onGenerateGitCredentialsButtonClicked}>
                    {VCResources.CreatePatButtonText}
                </DefaultButton>
            )
        }
    }
    else {
        return (
            props.isGenerateGitCredentialsButtonClicked
                ? <div className="git-getting-started-credentials-container">
                    {props.errorMessage &&
                        <MessageBar
                            className="error-message-bar"
                            onDismiss={props.onDismissErrorMessage}
                            messageBarType={MessageBarType.error}>
                            {props.errorMessage}
                        </MessageBar>
                    }
                    <span className="vc-inline-git-credentials-control-body">
                        <AsyncPatTokenComponent {...props.patTokenComponentProps} />
                    </span>
                </div>
                : <DefaultButton
                    id="vc-inline-git-credentials-create-credentials-button"
                    ariaLabel={VCResources.CreatePatButtonText}
                    onClick={props.onGenerateGitCredentialsButtonClicked}>
                    {VCResources.CreatePatButtonText}
                </DefaultButton>
        );
    }   
}

const AsyncPatTokenComponent = getAsyncLoadedComponent<PatTokenComponent_Async.PatTokenComponentProps>(
    ["VersionControl/Scenarios/NewGettingStarted/Components/GitCredentials/PatTokenComponent"],
    (module: typeof PatTokenComponent_Async) => module.PatTokenComponent,
    () => { return <Spinner className="wait-spinner" /> },
    () => { delayAnnounceHelper.startAnnounce(VCResources.GitCredentials_StartedLoadingComponent) },
    () => { delayAnnounceHelper.stopAndCancelAnnounce(VCResources.GitCredentials_CompletedLoadingComponent) });
